export enum FeatureToggle {
  PpdoAnalyticsToggles = 'rt_retailer_enablement_pickup_ppdo_fe_toggles',
  InstacartManagedReportsV2 = 'rt_instacart_managed_reports_v2',
}
